import PropTypes from "prop-types";
import { isEmpty, compact } from "lodash";

import styles from "./showFields.module.css";
import { previewText } from "../../helpers/cellPreview";
// TODO: optional show map
function Address({ value = {}, property = {}, options = {} }) {
  // Table layout: collapse to a single truncated line (full value via title).
  if (options.truncate) {
    const joined = compact([
      property.with_name ? value.name : null,
      compact([value.street, value.number]).join(" "),
      compact([value.zip, value.city]).join(" "),
      value.country,
    ]).join(", ");
    return (
      <div className={styles.Address} title={joined}>
        {previewText(joined)}
      </div>
    );
  }
  return (
    <div className={styles.Address}>
      {property.with_name && !isEmpty(value.name) ? (
        <span className="name">{value.name}</span>
      ) : null}
      <span className="street-number">
        {compact([value.street, value.number]).join(" ")}
      </span>
      <span className="zip-city">
        {compact([value.zip, value.city]).join(" ")}
      </span>
      {!isEmpty(value.country) ? (
        <span className="country">{value.country}</span>
      ) : null}
    </div>
  );
}
Address.propTypes = {
  value: PropTypes.shape({
    name: PropTypes.string,
    street: PropTypes.string,
    number: PropTypes.string,
    zip: PropTypes.string,
    city: PropTypes.string,
    country: PropTypes.string,
  }),
  property: PropTypes.shape({
    with_name: PropTypes.bool,
  }),
  options: PropTypes.shape({ truncate: PropTypes.bool }),
};

export default Address;
